import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=54f6de53"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"
import style0 from "./Icon.vue?vue&type=style&index=0&id=54f6de53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports